module.exports = __webpack_public_path__ + "static/img/12.bbb5545a.jpg";